/**
 * Formats a YYYY-MM-DD date string to DD/MM/YYYY (Argentine format).
 * Returns null for empty or invalid dates.
 */
export const formatDate = (dateStr) => {
    if (!dateStr) return null;

    // Strip time component if present
    const datePart = String(dateStr).trim().split(/[\sT]/)[0];

    // YYYY-MM-DD  →  DD/MM/YYYY
    const iso = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (iso) {
        const [, y, m, d] = iso;
        if (y === '0000') return null;
        if (m === '00' || d === '00') return y;   // only year is known
        return `${d}/${m}/${y}`;
    }

    // Bare 4-digit year
    if (/^\d{4}$/.test(datePart)) return datePart;

    return null;
};
